import { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

export const usePutApi = (initialUrl, initialData) => {
  const [data, setData] = useState(initialData);
  const [url, setUrl] = useState(initialUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const doPut = async (putData, overrideUrl = url) => {
    setIsError(false);
    setIsLoading(true);
    const csrfToken = Cookies.get('csrftoken');
    const headers = {
      'X-CSRFToken': csrfToken,
    };

    if (!(putData instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    try {
      const result = await axios.put(overrideUrl, putData, { headers, withCredentials: true });

      if (result.status === 200 || result.status === 201) {
        setData(result.data);
        setIsLoading(false);
        return { success: true, data: result.data };
      } else {
        setIsError(true);
        setIsLoading(false);
        return { success: false, error: 'Erreur lors de la requête' };
      }
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      return { success: false, error };
    }
  };

  return [{ data, isLoading, isError }, doPut, setUrl];
};
